import { Link } from "react-router-dom";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useCallback } from "react";

import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Modal,
  Popover,
} from "@mui/material";
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import {
  getAdListofUser,
  updateAdAction,
} from "../../redux/action-creators/adAction";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import { UserCommonStyles } from "../../styles/CommonStyles";
import { ProfileStyle } from "../profile/ProfileStyle";
import { RoutingLinks } from "../../utils/constants";
import ApiResponse from "../../interfaceModules/IApiResponse";
import {
  ChatBubbleOutline,
  HighlightOff,
  HighlightOffOutlined,
} from "@mui/icons-material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { HomeStyles } from "../../styles/HomeStyles";
import {
  capitalize,
  isJsonString,
  utcHoursDifference,
} from "../../utils/helper";
import moment from "moment";
import SocialIconSection from "../../components/sidebars/SocialIconSection";
import { toast } from "../../utils/toastsMessage";
import ClipLoader from "react-spinners/ClipLoader";

const AdList: React.FC = (props: any) => {
  const commonStyle = UserCommonStyles();
  const { t: translation } = useTranslation();
  const currentDate = utcHoursDifference(new Date());
  const [adAction, setAdAction] = useState({
    adId: 0,
    isActive: 0,
    loader: false,
    is_expire: false,
  });
  const [adViewCommentId, setAdViewCommentId] = useState(0);
  const [adList, setAdList] = useState<any>([]);
  const styleClasses = ProfileStyle();
  const homeClasses = HomeStyles();
  const dispatch = useDispatch();
  const [modalopen, setOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [anchorEl, setAnchorEl] =
    React.useState<HTMLButtonElement | null>(null);
  const [pauseAndResumeAdModal, setPauseAndResumeAdModal] =
    useState<boolean>(false);
  const open = Boolean(anchorEl);

  const handleOpen = (id: number) => {
    setAdViewCommentId(id);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const data = props?.location?.state;

  const userInfo = useSelector((state: RootStateOrAny) => {
    let userData = state.authReducer.authData;
    if (isJsonString(state.authReducer.authData)) {
      userData = JSON.parse(state.authReducer.authData);
    }
    return userData;
  });

  interface Column {
    autoNumber: number;
    id:
      | "companyname"
      | "url"
      | "email"
      | "startdate"
      | "enddate"
      | "phonenumber"
      | "address"
      | "status"
      | "package"
      | "adminComment"
      | "edit"
      | "play"
      | "view"
      | "click";
    label: string;
    minWidth?: number;
    align?: "right";
    format?: (value: number) => string;
  }
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#fff",
    p: 4,
  };

  const columns: readonly Column[] = [
    { autoNumber: 1, id: "companyname", label: "Company Name", minWidth: 170 },
    { autoNumber: 2, id: "url", label: "URL", minWidth: 100 },
    {
      autoNumber: 3,
      id: "email",
      label: "Email",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toLocaleString("en-US"),
    },
    {
      autoNumber: 4,
      id: "startdate",
      label: "Start Date",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toLocaleString("en-US"),
    },
    {
      autoNumber: 13,
      id: "enddate",
      label: "End Date",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toLocaleString("en-US"),
    },
    {
      autoNumber: 5,
      id: "phonenumber",
      label: "Contact Info",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toLocaleString("en-US"),
    },
    {
      autoNumber: 6,
      id: "address",
      label: "Address",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toFixed(2),
    },
    {
      autoNumber: 7,
      id: "status",
      label: "Status",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toFixed(2),
    },
    {
      autoNumber: 8,
      id: "package",
      label: "Package",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toFixed(2),
    },
    {
      autoNumber: 9,
      id: "view",
      label: "Total View",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toFixed(2),
    },
    {
      autoNumber: 10,
      id: "click",
      label: "Total Click",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toFixed(2),
    },
    {
      autoNumber: 11,
      id: "adminComment",
      label: "Admin Comment",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toFixed(2),
    },

    {
      autoNumber: 12,
      id: "edit",
      label: "Action",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toFixed(2),
    },

    // {
    //   autoNumber: 13,
    //   id: "play",
    //   label: "Action",
    //   minWidth: 170,
    //   align: "right",
    //   format: (value: number) => value.toFixed(2),
    // },
  ];

  useEffect(() => {
    if (adList.length === 0) {
      getAdList();
    }
  }, [adList]);

  /**
   * fetch all ad packages list
   * @param id
   */
  const getAdList = useCallback(async () => {
    await getAdListofUser(userInfo.id).then((response: ApiResponse) => {
      const { data, error } = response;
      if (data?.data[0]?.length > 0 && data?.data[0]?.admin_comments != null) {
        for (let i = 0; i < data.data[0].length; i++) {
          let result = data.data[0][i]?.admin_comments;
          if (result !== "") {
            result = JSON.parse(result);
            data.data[0][i].admin_comments = result;
          }
        }
      }
      setAdList(data?.data[0]);
    });
    setLoader(false);
  }, [dispatch]);

  const addPackage = (adId: number, company_name: string) => {
    props.history.push({
      pathname: "/adpackages",
      state: { id: adId, company_name: company_name },
    });
  };

  const updateAdActionStatus = async () => {
    setAdAction((prev) => ({ ...prev, loader: true }));
    const data = { isActive: adAction.isActive };
    const response: any = await dispatch(
      updateAdAction(adAction.adId, userInfo.id, data)
    );
    if (response && response.status == 201) {
      getAdList();
      setAdAction({ adId: 0, isActive: 0, loader: false, is_expire: false });
      setPauseAndResumeAdModal(false);
    } else {
      setAdAction({ adId: 0, isActive: 0, loader: false, is_expire: false });
      setPauseAndResumeAdModal(false);
      return toast.error("Something went wrong. Please try again later.");
    }
  };

  const createAd = () => {
    if (adList.length > 0) {
      let temp = [];
      adList.map((ad: any) => {
        let end_date = moment(ad?.end_date);
        const isExpire = moment(new Date()).diff(end_date, "days");
        if (isExpire <= 0) {
          temp.push(isExpire);
        }
      });
      if (temp.length > 0) {
        return toast.info(
          "A new ad can't be created right now because another ad is currently running."
        );
      } else {
        return props.history.push("/adcenter");
      }
    } else {
      return props.history.push("/adcenter");
    }
  };

  return (
    <Box className={commonStyle.windowColor}>
      <Grid container>
        <Grid item md={3}>
          <LeftSidebar />
          {/* <SocialIconSection /> */}
        </Grid>

        <Grid item md={9}>
          <Box className={`${commonStyle.p20} ${commonStyle.mt20}`}>
            <Typography
              variant="h6"
              className={`${commonStyle.grey} ${commonStyle.mb15} ${commonStyle.fontWeight600}`}
            >
              {translation("adlist")}
            </Typography>

            <Box
              className={`${commonStyle.flexCenter} ${commonStyle.justifyEnd}`}
            >
              <Box
                className={`${commonStyle.mb10} ${commonStyle.textRight} ${commonStyle.mr5}`}
              >
                <Box className={commonStyle.orangeBtn}>
                  <Button
                    onClick={() => props.history.push("/adcenter")}
                    // onClick={createAd}
                  >
                    {translation("create_ad")}
                  </Button>
                </Box>
              </Box>

              {/* <Box
                className={`${commonStyle.mb10} ${commonStyle.textRight} ${commonStyle.mr5}`}
              >
                <Box className={commonStyle.orangeBtn}>
                  <Button onClick={() => props.history.push("/cards")}>
                    {translation("add_bal")}
                  </Button>
                </Box>
              </Box> */}

              {/* <Box className={`${commonStyle.mb10} ${commonStyle.textRight}`}>
                <Box className={commonStyle.orangeBtn}>
                  <Button onClick={() => props.history.push("/view-balance")}>
                    {translation("view_balance")}
                  </Button>
                </Box>
              </Box> */}
            </Box>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label={translation("sticky_table")}>
                <TableHead>
                  <TableRow className={commonStyle.commonTableHead}>
                    {columns.map((column, index) => (
                      <TableCell
                        key={column.autoNumber}
                        style={{ minWidth: column.minWidth }}
                        align={index == 0 ? "left" : "center"}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adList && adList.length > 0
                    ? adList.map((ad: any, index: number) => {
                      console.log('ad :>> ', ad);
                        let start_date = utcHoursDifference(ad.start_date);
                        let end_date = utcHoursDifference(ad?.end_date);
                        const isExpire = moment(currentDate).diff(
                          end_date,
                          "days"
                        );
                        return (
                          <TableRow hover tabIndex={-1} key={index}>
                            <TableCell align="left">
                              {ad?.company_name
                                ? capitalize(ad?.company_name)
                                : ""}
                            </TableCell>
                            <TableCell align="center">
                              {ad?.company_website_url
                                ? ad?.company_website_url
                                : ""}
                            </TableCell>
                            <TableCell align="center">
                              {ad.email ? ad.email : ""}
                            </TableCell>

                            <TableCell align="center">
                              {start_date
                                ? moment(start_date).format("DD MMM, YYYY")
                                : ""}
                            </TableCell>
                            <TableCell align="center">
                              {/* {ad.end_date
                                ? moment(ad.end_date).format("DD MMM, YYYY")
                                : ""} */}
                              {end_date
                                ? moment(end_date).format("DD MMM, YYYY")
                                : ""}
                            </TableCell>
                            <TableCell align="center">
                              {ad?.phone_number ? ad?.phone_number : ""}
                            </TableCell>
                            <TableCell align="center">
                              {ad?.address ? ad?.address : ""}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                color:
                                  ad?.is_active == 1 && isExpire <= 0
                                    ? "#01B4BC"
                                    : isExpire > 0
                                    ? "#D95557"
                                    : "#000000",
                              }}
                            >
                              {/* {ad.is_active == 1 ? "Approved" : "Pending for approval"} */}
                              {/* {ad?.is_active == 1 && isExpire <= 0 ? "Continue" : ad?.is_active == 2 && isExpire <= 0 ? "Pause" : isExpire > 0 && "Expired"} */}
                              {isExpire <= 0 && ad?.is_active === 0
                                ? "Pending for approval"
                                : isExpire <= 0 && ad?.is_active === 2
                                ? "Pause"
                                : ad?.is_active == 1 && isExpire <= 0
                                ? "Approved"
                                : isExpire > 0 && "Expired"}
                            </TableCell>
                            <TableCell align="center">
                              {ad?.package ? ad?.package : ""}
                            </TableCell>
                            <TableCell align="center">
                              {ad?.view_count ? ad?.view_count : "0"}
                            </TableCell>
                            <TableCell align="center">
                              {ad?.click_count ? ad?.click_count : "0"}
                            </TableCell>

                            {ad?.admin_comments?.length > 0 ? (
                              <TableCell align="center">
                                <Box className={commonStyle.orangeBtn}>
                                  <Button onClick={() => handleOpen(ad?.id)}>
                                    {translation("View Comments")}
                                  </Button>
                                </Box>
                              </TableCell>
                            ) : (
                              <TableCell align="center">
                                No Comment Found
                              </TableCell>
                            )}

                            {ad?.admin_comments?.length > 0 &&
                              ad?.id === adViewCommentId && (
                                <Modal
                                  open={modalopen}
                                  onClose={handleClose}
                                  aria-labelledby="child-modal-title"
                                  aria-describedby="child-modal-description"
                                >
                                  <Box className={commonStyle.commonModalStyle}>
                                    <Box
                                      className={`${homeClasses.modalHeader} ${commonStyle.px10}`}
                                    >
                                      <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                      >
                                        {translation("Admin Comments")}
                                      </Typography>
                                      <HighlightOff onClick={handleClose} />
                                    </Box>

                                    <Box className={`${commonStyle.p20}`}>
                                      <Table size="small">
                                        <TableHead>
                                          <TableRow>
                                            <TableCell>Date</TableCell>
                                            <TableCell>Comments</TableCell>
                                          </TableRow>
                                        </TableHead>

                                        <TableBody>
                                          {ad.id === adViewCommentId &&
                                            ad?.admin_comments?.length > 0 &&
                                            JSON.parse(ad?.admin_comments).map(
                                              (item: any, index: number) => {
                                                return (
                                                  <TableRow>
                                                    <TableCell key={index}>
                                                      {item?.date
                                                        ? item?.date
                                                        : ""}
                                                    </TableCell>
                                                    <TableCell>
                                                      {item?.comment
                                                        ? item?.comment
                                                        : ""}
                                                    </TableCell>
                                                  </TableRow>
                                                );
                                              }
                                            )}
                                        </TableBody>
                                      </Table>
                                    </Box>
                                  </Box>
                                </Modal>
                              )}

                            <TableCell align="center">
                              {/* {ad?.is_active === 1 ? ( */}
                              <Button
                                variant="text"
                                onClick={(
                                  event: React.MouseEvent<HTMLButtonElement>
                                ) => {
                                  if (ad?.is_active === 0) {
                                    setAnchorEl(event.currentTarget);
                                    setAdAction({
                                      adId: ad?.id,
                                      isActive: ad?.is_active,
                                      loader: false,
                                      is_expire: isExpire > 0,
                                    });
                                    // return setPauseAndResumeAdModal(true);
                                    // return toast.info("The ad is currently pending for approval for now, you can't perform any actions.")
                                  } else {
                                    setAnchorEl(event.currentTarget);
                                    setAdAction({
                                      adId: ad?.id,
                                      isActive: ad?.is_active,
                                      loader: false,
                                      is_expire: isExpire > 0,
                                    });
                                  }
                                }}
                              >
                                <MoreHorizIcon
                                  sx={{
                                    fontSize: 40,
                                    fontWeight: "300",
                                    color: "#000000",
                                  }}
                                />
                              </Button>
                              {/* ) : (
                              <Box className={commonStyle.orangeBtn}>
                                <Button
                                  onClick={() => {
                                    setAdAction({
                                      adId: ad?.id,
                                      isActive: ad?.is_active,
                                      loader: false,
                                      is_expire: false
                                    });
                                    setPauseAndResumeAdModal(true);
                                  }}>{"Resume"}</Button>
                              </Box>
                            )} */}
                              <Popover
                                open={open}
                                anchorEl={anchorEl}
                                onClose={() => {
                                  setAnchorEl(null);
                                  setAdAction({
                                    adId: 0,
                                    isActive: 0,
                                    loader: false,
                                    is_expire: false,
                                  });
                                }}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "left",
                                }}
                                className={styleClasses.popoverShadow}
                              >
                                <ul
                                  className={`${styleClasses.ad_ActionPopup}`}
                                >
                                  {!adAction.is_expire ? (
                                    <>
                                      <li
                                        onClick={() => {
                                          setAnchorEl(null);
                                          props.history.push(
                                            `${RoutingLinks.editAd}${adAction.adId}`
                                          );
                                        }}
                                      >
                                        {"Edit"}
                                      </li>
                                      {adAction.isActive === 0 ? null : (
                                        <li
                                          onClick={() => {
                                            setAnchorEl(null);
                                            setPauseAndResumeAdModal(true);
                                          }}
                                        >
                                          {" "}
                                          {adAction.isActive === 1
                                            ? "Pause"
                                            : adAction.isActive === 2
                                            ? "Resume"
                                            : ""}
                                        </li>
                                      )}

                                      <li
                                        onClick={() => {
                                          setAnchorEl(null);
                                          props.history.push(
                                            `${RoutingLinks.adPromote}${adAction.adId}`
                                          );
                                        }}
                                      >
                                        {" "}
                                        {"Promote"}
                                      </li>
                                      <li
                                        onClick={() => {
                                          setAnchorEl(null);
                                          props.history.push(
                                            `${RoutingLinks.adStatsGraph}${adAction.adId}`
                                          );
                                        }}
                                      >
                                        {" "}
                                        {"Stats Graph"}
                                      </li>
                                    </>
                                  ) : (
                                    <li
                                      onClick={() => {
                                        setAnchorEl(null);
                                        props.history.push(
                                          `${RoutingLinks.adStatsGraph}${adAction.adId}`
                                        );
                                      }}
                                    >
                                      {" "}
                                      {"Stats Graph"}
                                    </li>
                                  )}
                                </ul>
                              </Popover>
                            </TableCell>
                            {/* <TableCell>
                              <Box className={commonStyle.orangeBtn}>
                                <Button
                                  onClick={() =>
                                    handleAlertOpen(ad.id, ad.status)
                                  }
                                  disabled={ad.status === 0 || ad.status === 3}
                                >
                                  {ad.status === 1 ? "Pause" : "Resume"}
                                </Button>
                              </Box>
                            </TableCell> */}
                          </TableRow>
                        );
                      })
                    : loader
                    ? translation("loading")
                    : translation("no_ad_avail")}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
      <Modal
        open={pauseAndResumeAdModal}
        onClose={() => {
          setPauseAndResumeAdModal(false);
          setAdAction({
            adId: 0,
            isActive: 0,
            loader: false,
            is_expire: false,
          });
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box className={commonStyle.py15}>
            <Box className={commonStyle.textCenter}>
              <Typography
                className={`${commonStyle.font16} ${commonStyle.fontWeight400}`}
                pb={1}
              >
                {adAction.isActive == 1
                  ? "Are you sure, you want to pause ad ?"
                  : adAction.isActive == 2
                  ? "Are you sure, you want to resume ad ?"
                  : // : adAction.isActive === 0
                    // ? "The advertisement is currently awaiting approval from the administrator. During this time, no actions can be performed."
                    null}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "50px",
                marginTop: "15px",
              }}
            >
              {adAction.isActive === 0 ? null : (
                <Box className={`${commonStyle.without_bg_blue_btn}`}>
                  <Button
                    onClick={() => {
                      setPauseAndResumeAdModal(false);
                      setAdAction({
                        adId: 0,
                        isActive: 0,
                        loader: false,
                        is_expire: false,
                      });
                    }}
                  >
                    {"No"}
                  </Button>
                </Box>
              )}

              <Box className={` ${commonStyle.blueBtn} ${commonStyle.w150}`}>
                {adAction.isActive === 0 ? (
                  <Button
                    fullWidth
                    onClick={() => {
                      setPauseAndResumeAdModal(false);
                      setAdAction({
                        adId: 0,
                        isActive: 0,
                        loader: false,
                        is_expire: false,
                      });
                    }}
                  >
                    {"Ok"}
                  </Button>
                ) : (
                  <Button
                    fullWidth
                    onClick={updateAdActionStatus}
                    disabled={adAction.loader}
                  >
                    {"Yes "}
                    {adAction.loader ? <ClipLoader /> : null}
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AdList;
